import React from 'react';
import { formatDate } from 'Shared/Utils';
import styles from './MessageSeparator.module.scss';

type MessageSeparatorProps = {
  timestamp: string;
};

export const MessageSeparator: React.FC<MessageSeparatorProps> = ({
  timestamp,
}) => {
  return (
    <div className={styles.messageSeparator}>
      {formatDate({
        date: timestamp,
        outputFormat: 'numericDay_shortMonth',
      })}
    </div>
  );
};
